import React from "react"

import { cn } from "@/lib/utils"
import { TAdProps } from "@/components/ui/molecules/ad/summary/AdSummary"
import { RichTextSync, Typography } from "@/components/ui/atoms"
import { Picture } from "@/components/ui/molecules"

const AdNews = async ({ data }: TAdProps) => {
  const isOrange = data.backgroundColor === "orange"
  return (
    <div
      className={cn(
        "ad-news rounded-100 p-5 lg:px-9 lg:py-0",
        isOrange
          ? "bg-accent-500"
          : data.backgroundColor === "beige"
            ? "bg-secondary-400"
            : "bg-neutral-100"
      )}
    >
      <div className="items-center md:flex">
        <Picture
          src={data.image.url + "?h=1800&w=1600&fm=webp&q=80"}
          alt={data.image.description ? data.image.description : ""}
          className="hidden self-end md:flex md:w-5/12 md:pb-0 md:pt-6"
          width={data.image.width}
          height={data.image.height}
          isSemiCircle={true}
        />
        <Picture
          src={data.image.url + "?h=1800&w=1600&fm=webp&q=80"}
          alt={data.image.description ? data.image.description : ""}
          className="pb-7 md:hidden"
          width={data.image.width}
          height={data.image.height}
          isSemiCircle={true}
        />
        <div className="md:w-1/12"></div>
        <div className="items-center md:w-6/12 md:py-5">
          <Typography
            as="h2"
            className={cn("mb-7 font-500", isOrange ? "text-neutral-100" : "")}
            variant="headingM"
          >
            {data.title}
          </Typography>
          <RichTextSync
            className={cn(
              "ad-news-richtext",
              isOrange ? "text-neutral-100" : ""
            )}
            blockTitle={data.title}
            body={data.text}
          />
        </div>
      </div>
    </div>
  )
}

export { AdNews }
